package com.github.reapermaga.portfolio.components

import dev.fritz2.core.RenderContext

fun RenderContext.gridPattern() {
    div("grid-pattern absolute w-screen h-full") {}
}